import { t as ArchiveLimitError } from "../archive-limits-CMo2zcn-.js";
import { Reader } from "@zip.js/zip.js";
//#region ../src/storage/zip-byte-source-reader.ts
/**
* Adapts a {@link ByteSource} to a zip.js `Reader`.
*
* This is the whole reason zip.js sees a `ByteSource` at all: it parses the
* central directory and decompresses entries, while every actual byte read is
* delegated to the source beneath — which may be a remote Range fetch or a
* local cache, and may switch between them mid-session without zip.js ever
* noticing (see `SwitchableByteSource`).
*/
var ByteSourceReader = class extends Reader {
	#source;
	#maxReadBytes;
	/**
	* @param maxReadBytes the largest single read zip.js may make through
	*   this reader (`ArchiveLimits.maxDirectoryBytes` for an untrusted
	*   archive, K0 milestone review R4): zip.js reads a central directory in
	*   ONE read of the size its end record declares, so a larger read is
	*   refused before the source is asked. Entry data comes in 64 KiB
	*   chunks. Unbounded when omitted (a trusted archive).
	*/
	constructor(source, maxReadBytes = Number.POSITIVE_INFINITY) {
		super(source);
		this.#source = source;
		this.#maxReadBytes = maxReadBytes;
		this.size = source.size;
	}
	readUint8Array(index, length) {
		const clamped = Math.max(0, Math.min(length, this.size - index));
		if (clamped === 0) return Promise.resolve(new Uint8Array(0));
		if (clamped > this.#maxReadBytes) return Promise.reject(new ArchiveLimitError("directory-bytes", this.#maxReadBytes, clamped));
		return this.#source.read(index, clamped);
	}
};
//#endregion
export { ByteSourceReader };
